import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { breadcrumbsPropTypes } from '../../../../common/resource/proptypes/CommonPropTypes';
import { DEFAULT_PAGE_SIZE } from '../../../../../config/constants';
import ModuleList from '../../../../layout/ModuleList';
import { clearBoardingGroups, getBoardingGroups } from '../../../../../actions/itinerary/BoardingGroup';
import { BOARDING_GROUPS_COLUMN } from '../../../../../config/columns';
import { BOARDING_GROUP_PATH, NEW_BOARDING_GROUP_PATH } from '../../../../../config/paths';

const BoardingGroups = ({
  breadcrumbs,
  boardingGroups,
  loading,
  dispatchGetBoardingGroups,
  dispatchClearBoardingGroups,
}) => {
  useLayoutEffect(() => () => dispatchClearBoardingGroups(), []);

  const data = boardingGroups.get('content') || [];
  const pages = boardingGroups.get('totalPages') || null;
  const defaultPageSize = boardingGroups.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Grupos de Embarque"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_BOARDING_GROUP_PATH}
      tableStructure={{
        columns: BOARDING_GROUPS_COLUMN,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetBoardingGroups,
        modelPath: BOARDING_GROUP_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
      toolbar
    />
  );
}

BoardingGroups.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  boardingGroups: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool,
  dispatchGetBoardingGroups: PropTypes.func.isRequired,
  dispatchClearBoardingGroups: PropTypes.func.isRequired,
};

BoardingGroups.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchGetBoardingGroups: getBoardingGroups,
  dispatchClearBoardingGroups: clearBoardingGroups,
};

const mapStateToProps = ({ ItineraryUnit }) => ({
  breadcrumbs: [
    ...ItineraryUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Grupos de Embarque',
      href: '',
    },
  ],
  boardingGroups: ItineraryUnit.BoardingGroup.getIn(['all', 'content']),
  loading: ItineraryUnit.BoardingGroup.getIn(['all', 'loading']),
});

export default connect(mapStateToProps, mapDispatchToProps)(BoardingGroups);